export const GET_INVOICE_LOADING = "INVOICE_loading";
export const GET_INVOICE_SUCCESS = "INVOICE_success";
export const GET_INVOICE_FAILED = "INVOICE_failed";
